import { execute } from '@/graphql/execute';
import { projectOfflineManifestQuery } from '@/queries/offlineManifest.query';
import type { ManifestFile } from './downloadManager';

/**
 * Fetches the offline manifest for a project and maps it into the plain
 * `ManifestFile[]` shape the download manager consumes. The `kind`
 * (`LayerType` enum) is mapped to a string.
 */
export async function loadManifest(projectId: string): Promise<{
  files: ManifestFile[];
  totalBytes: number;
  layerVersions: Record<string, string>;
}> {
  const data = await execute(projectOfflineManifestQuery, { projectId });
  const m = data.projectOfflineManifest;
  return {
    files: m.files.map((f) => ({
      url: f.url,
      sizeBytes: f.sizeBytes,
      layerId: f.layerId,
      kind: String(f.kind),
    })),
    totalBytes: m.totalBytes,
    layerVersions: m.layerVersions as Record<string, string>,
  };
}
